import { GalleryModel } from "./model.js";
import { GalleryView } from "./view.js";

export class GalleryController {
  constructor(_base) {
    this.isNew = false;
    this.view = new GalleryView(_base);
    this.model = new GalleryModel(_base);
    this.base = _base;
  }

  create(_images) {
    this.images = _images;
    if (_images && typeof _images == 'string' && _images.length > 0) {
      try {
        this.images = JSON.parse(_images);
      } catch (error) {
        console.log(error)
      }
    }
    if (!Array.isArray(this.images)) {
      this.images = [];
    }

    return this.view.render(this.images);
  }

  checkButtons() {
    document.getElementById('gallery-btn-new').classList.add('hide');
    document.getElementById('gallery-btn-change').classList.add('hide');
    document.getElementById('gallery-btn-delete').classList.add('hide');

    if (document.getElementById('gallery').getAttribute('open')) {
      document.getElementById('gallery-btn-change').classList.remove('hide');
      document.getElementById('gallery-btn-delete').classList.remove('hide');
    } else {
      document.getElementById('gallery-btn-new').classList.remove('hide');
    }
  }


  showImage(_idcod) {
    document.getElementById('gallery-visor').setAttribute('style', this.view.getBackground(_idcod, false));
    document.getElementById('gallery').setAttribute('open', _idcod);
    this.checkButtons();
  }

  delete() {
    let idcod = document.getElementById('gallery').getAttribute('open');
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i] == idcod) {
        this.images.splice(i, 1);
        this.refresh();
        return;
      }
    }
  }

  add() {
    this.isNew = true;
    document.getElementById('gallery-input')?.click();
  }

  change() {
    document.getElementById('gallery-input')?.click();
  }

  refresh() {
    document.getElementById('gallery').innerHTML = this.create(this.images);
  }


  upload(_elem) {
    document.getElementById('gallery-loading').classList.add('active');
    if (this.isNew === true) {
      document.getElementById('gallery-loading-text').innerHTML = 'Creando imagen';
    } else {
      document.getElementById('gallery-loading-text').innerHTML = 'Reemplazando imagen';
    }
    let idcod = document.getElementById('gallery').getAttribute('open');
    this.model.upload(_elem, idcod, this.isNew, this.images)
      .then(response => {
        this.images = response.images;
        this.isNew = false;
        document.getElementById('gallery-thumbs').innerHTML = this.view.renderThumbs(response.images);
        document.getElementById('gallery').setAttribute('data', JSON.stringify(response.images));
        this.refresh();
        this.showImage(response.idcod);
        setTimeout(() => {
          document.getElementById('gallery-loading').classList.remove('active');
          document.getElementById('gallery-loading-text').innerHTML = '';
        }, 2000);
      })
      .catch(error => {
        console.error(error);
      });
  }
}
